export const scan = {
  modes: {
    single: { title: "Photograph one item", short: "One item, finished listing", description: "Take a photo and we'll write the listing and suggest a price." },
    photos: { title: "Photograph several items", short: "Up to 30 photos", description: "Upload a batch of photos — we'll group them by item." },
    video: { title: "Video scan", short: "Film a room", description: "Film for up to 60 seconds and we'll list everything we find." },
    deep: { title: "Deep scan", short: "Expert valuation", description: "We examine one item in depth: model, condition and actual sale prices produce a more reliable valuation." },
  },
  capture: {
    cameraTitle: "Photograph your item",
    chooseTitle: "How would you like to add the photo?",
    cameraDescription: "Keep the item in frame and press the button. You can take several photos.",
    chooseDescription: "Use your device camera, choose a file, or drag and drop photos here.",
    takeWithCamera: "Take a photo with the camera",
    chooseDevice: "Choose from device",
    dropHint: "…or drag and drop photos into this box.",
    retry: "Try again",
    chooseComputer: "Choose photos from computer",
    starting: "Starting camera…",
    shotAlt: "Photo {{count}}",
    removeShot: "Remove photo",
    takeShot: "Take photo",
    back: "Back",
    usePhoto: "Use this photo",
    useShots: "Use {{count}} photos",
    embeddedError: "The browser cannot access the camera here. Open the site in a separate tab and try again, or choose photos from your computer.",
    cameraError: "We couldn't access the camera. Allow camera access in your browser and try again, or choose photos from your computer.",
    frameError: "The camera did not produce an image yet. Wait a second and try again.",
    doneFrameError: "The camera did not produce an image yet. Press Take photo again in a moment.",
    shotsCounter: "{{count}} of {{max}} photos",
    limitReached: "Your plan allows up to {{max}} photos per listing.",
    limitReachedUpgrade: "The Free plan allows {{max}} photos per listing. Upgrade to Plus for 6 photos.",
    limitUpgradeLink: "See plans and pricing",
    clippedBody: "You chose {{count}} photos – only the first {{max}} fit.",
    clippedConfirm: "Continue with the first {{max}}",
    clippedCancel: "Choose again",
  },
} as const;
